// Silver
export default [
    {type: "freeplay", to: "$3"},
    {type: "weekly_rakeback", to: "7%"},
    {type: "monthly_rakeback", to: "5%"},
    {type: "birthday_bonus", to: "$15 + 10%"},
    {type: "deposit_assist_token", to: "$1"}
]